import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Widget, WidgetSimpleList } from '@factorialco/f0-react/dist/experimental'
import {
  OpenPositionsHomeWidgetDocument,
  OpenPositionsHomeWidgetQuery,
} from 'generated/resources/graphql'
import kebabCase from 'lodash/kebabCase'
import orderBy from 'lodash/orderBy'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { buildWidget } from 'modules/core/lib/widgets'

import { NEW_HOME_WIDGETS, NEW_HOME_WIDGET_ACTION_TYPES } from 'modules/dashboard/lib/events'

import './index.styles.css'
const prepareData = (data: OpenPositionsHomeWidgetQuery) => {
  const orderedData = orderBy(data.ats.openPositionsLocationsConnection.nodes, (item) => item.id)

  return {
    title: i18n.t('new_dashboard.open_positions.title'),
    items: orderedData
      .filter((item) => item.openPositionsCount > 0)
      .map((location) => ({
        id: location.id.toString(),
        title: location.id,
        count: location.openPositionsCount,
      })),
    count: orderedData.reduce((total, item) => total + item.openPositionsCount, 0),
  }
}

type PreparedData = ReturnType<typeof prepareData>

const OpenPositionsWidgetComponent: FC<{ data: PreparedData; employeeId: string }> = ({
  data: { title, items, count },
}) => {
  const navigate = useNavigate()

  const { navigation } = useNavigation()

  const linkUrl = navigation.ats.openPositions.fullPath()

  const handleUpperRightActionClick = () => {
    track(trackingEvents.dashboard.clickOnHomeWidgetAction, {
      widget: NEW_HOME_WIDGETS.OPEN_POSITIONS,
      actionType: NEW_HOME_WIDGET_ACTION_TYPES.UPPER_RIGHT_BUTTON,
    })
  }

  const link = {
    url: linkUrl,
    title,
    onClick: handleUpperRightActionClick,
  }

  const handleClickItem = (id: string | number) => {
    track(trackingEvents.dashboard.clickOnHomeWidgetItem, {
      widget: NEW_HOME_WIDGETS.OPEN_POSITIONS,
    })
    navigate(`${linkUrl}?${kebabCase(`${id}`)}`)
  }

  return (
    <Widget
      header={{
        title,
        link,
        count,
      }}
    >
      <Box className={'OpenPositions_container'}>
        <WidgetSimpleList items={items} onClickItem={handleClickItem} showAllItems />
      </Box>
    </Widget>
  )
}

export const buildOpenPositionsWidget = () =>
  buildWidget({
    id: 'open-positions',
    document: OpenPositionsHomeWidgetDocument,
    prepareData,
    isEmpty: ({ items }) => !items.length,
    component: OpenPositionsWidgetComponent,
  })
